import React, { useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_MEETS_CASE } from '../../../utilities';

const EventMeetCase = ({ meetCaseDef, textAreaMeetCase, handleNewTextAreaDelete }) => {
  let blankTextAreas = textAreaMeetCase.some(i => i=='')

  const addTextAreameetCase = () => {
    setTimeout(() => {
      meetCaseDef((prevTextAreas) => [...prevTextAreas, ""]);
    }, 400);
  };

  const handleTextAreaChangeMeetCase = (index, e) => {
    const value = e.target.value;

    const updated = [...textAreaMeetCase];
    updated[index] = value;
    meetCaseDef(updated);
  };


  const myFirstEleRef = useRef(null);
  return (
    

      <div className="ct_event_main">
        <div className="card w-100" 
        // style={{ width: "48rem" }}
        >
          <div className="card-header event_txtarea_header">
            Event meets case definition
          </div>
          <div className="ct_textarea_btn_div">
            <TransitionGroup>
              {textAreaMeetCase?.map((textAreaValue, index) => (
                <CSSTransition
                  nodeRef={myFirstEleRef}
                  key={index}
                  timeout={1000}
                  classNames="fade"
                >
                  <div className="textarea_item ">
                    {index !== 0 && <button
                      onClick={() => handleNewTextAreaDelete(textAreaMeetCase, index)}
                      className="minus_btn"
                      style={{ right: "8px" }}

                    >
                      <span>x</span>
                    </button>}
                    <textarea
                      name="meetCase"
                      value={textAreaValue}
                      onChange={(event) =>
                        handleTextAreaChangeMeetCase(index, event)
                      }
                      placeholder="Type event definition"
                    />
                  </div>
                </CSSTransition>
              ))}
            </TransitionGroup>
            <button disabled={blankTextAreas} onClick={addTextAreameetCase} className="plus_btn">
              <span>+</span>
            </button>
          </div>
        </div>




      </div>

    
  );
};

export default EventMeetCase;

export const EventMeetCaseAPIData = ({ meetUpdateCaseDef, handleNewTextAreaDelete, handleDeleteClick, textAreaAddMeetCase, leveldata,getTextAreaChange }) => {
  let levelData = leveldata;
  let blankTextAreas = textAreaAddMeetCase.some(i => i=='')
  const meetCaseForUpdate = () => {
    setTimeout(() => {
      meetUpdateCaseDef((prevTextAreas) => [...prevTextAreas, ""]);
      getTextAreaChange(true)
    }, 400);
  };


const [modifiedData, setModifiedData] = useState([])
  const handleTextAreaChangeMeetCase = (e, key) => {
   if(e.target.value ===''){
     getTextAreaChange(false)
     
    }else{
     getTextAreaChange(true)

   }
    const value = e.target.value;
    let matchedId = levelData.filter(i => {
      if (i.event_meets_case_id === key) {
        i.event_meets_case_definition = value
      }
    })   
    setModifiedData(matchedId)
  };
 
  const updatedDataforApi = (e, index) => {
    const value = e.target.value;
    const updatedValue = [...textAreaAddMeetCase];
    updatedValue[index] = value;
    meetUpdateCaseDef(updatedValue);

  }

  return (
     

      <div className="ct_event_main">
        <div className="card w-100" 
        // style={{ width: "48rem" }}
        >
          <div className="card-header event_txtarea_header">
            Event meets case definition
          </div>
          <div className="ct_textarea_btn_div">
              {levelData?.map((textAreaValue, index) => {
                return (
                
                    <div key={textAreaValue.event_meets_case_id}>
                      {index !==0 && <button
                        onClick={() => handleDeleteClick(EVENT_CLASSIFICATION_LEVEL_BRIGHTON, textAreaValue.event_meets_case_id, EVENT_MEETS_CASE)}
                        className="minus_btn"
                        style={{ right: "8px" }}
                      >
                        <span>x</span>
                      </button>}
                      <textarea
                        name="meetCase"
                        value={textAreaValue.event_meets_case_definition}
                        onChange={(event) =>
                          handleTextAreaChangeMeetCase(event, textAreaValue.event_meets_case_id)
                        }
                        placeholder="Type event definition"
                      />
                    </div>
                )
              })}
              {textAreaAddMeetCase?.map((txtArea, index) => {
                return (
                    <div className="textarea_item " key={index}>
                      <button
                        onClick={() => handleNewTextAreaDelete(textAreaAddMeetCase, index)}
                        className="minus_btn"
                        style={{ right: "8px" }}
                      >
                        <span>x</span>
                      </button>
                      <textarea
                        value={txtArea}
                        name='addtextarea'
                        onChange={(event) => updatedDataforApi(event, index)}
                        placeholder="Type event definition"
                      />

                    </div>
                )
              })}
            <button disabled={blankTextAreas || levelData[0]?.event_meets_case_definition===""} 
            onClick={meetCaseForUpdate} className="plus_btn">
              <span>+</span>
            </button>
          </div>
        </div>




      </div>

     
  );
};



